import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import UITable from 'UIComponents/table/UITable';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function RSSFeedList({
  feeds,
  onSelectFeed
}) {
  return /*#__PURE__*/_jsxs(UITable, {
    truncated: true,
    children: [/*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management-creation.createEmailPanel.blogRSS.rssFeed.feedList.title"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management-creation.createEmailPanel.blogRSS.rssFeed.feedList.url"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: ''
        })]
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: feeds.map(feed => /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("td", {
          children: /*#__PURE__*/_jsx(UITruncateString, {
            children: feed.title
          })
        }), /*#__PURE__*/_jsx("td", {
          children: /*#__PURE__*/_jsx(UILink, {
            href: feed.url,
            external: true,
            iconProps: {
              style: {
                display: 'none'
              }
            },
            children: /*#__PURE__*/_jsx(UITruncateString, {
              useFlex: true,
              fixedChildren: /*#__PURE__*/_jsx(UIIcon, {
                className: "m-left-2",
                name: "externalLink",
                size: "xxs"
              }),
              children: feed.url
            })
          })
        }), /*#__PURE__*/_jsx("td", {
          children: /*#__PURE__*/_jsx(UIButton, {
            size: "small",
            "data-test-id": `use-feed-button-${feed.url}`,
            use: "tertiary-light",
            onClick: () => onSelectFeed(feed.url),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "email-management-creation.createEmailPanel.blogRSS.rssFeed.feedList.use"
            })
          })
        })]
      }, feed.url))
    })]
  });
}